import React, { Component } from 'react'
import { list } from './apiUser';
import { Link } from 'react-router-dom';
import DefaultProfile from '../assets/avatar.jpg';

class Users extends Component {
  constructor() {
    super()
    this.state = {
      users: []
    }
  }

  componentDidMount() {
    list().then(data => {
      if (data.error) {
        console.log(data.error);
      } else {
        this.setState({ users: data });
      }
    });
  }

  /* 
  const lDate = Date.now();
  const photoUrl = user._id ? `${process.env.REACT_APP_API_URL}/user/photo/${user._id}?v=${lDate}` : DefaultProfile;
  */
  renderUsers = users => (
    <div className="row">
      {users.map((user, i) => (
        <div className="card col-md-3 col-sm-6 mb-4" key={i}>
          <img
            className="card-img-top rounded-circle mt-4 img-thumbnail img-fluid"
            style={{ width: 'auto', maxHeight: 200, margin: 'auto'}}
            src={`${process.env.REACT_APP_API_URL}/user/photo/${user._id}`}
            onError={i => (i.target.src = `${DefaultProfile}`)}
            alt={user.name}
          />
          <div className="card-body">
            <h5 className="card-title">{user.name}</h5>
            <p className="card-text">
              {user.email}
            </p>
            <Link to={`/user/${user._id}`} className="btn btn-raised btn-primary btn-sm">View Profile</Link>
          </div>
        </div>
      ))}
    </div>
  )

  render() {
    const { users } = this.state;
    return (
      <div className="container">
        <h2 className="mt-5">Users</h2>
        {this.renderUsers(users)}
      </div>
    )
  }
}

export default Users;
